import { AppBar, Avatar, Box, Button, Icon, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { User } from 'oidc-client';
import useAuth from '../hooks/useAuth';
import { Logout, MenuBook, Info, TextSnippet } from '@mui/icons-material';
import icon from '../assets/quanto_custa_logo.png';
import mpmg from '../assets/mpmg.png';
import gsi from '../assets/gsi.png';
import LogoCeat from "../assets/logo-ceat-branco.png"
import ceat from "../assets/ceat.png"
import navbar_background from '../assets/navbar_background.svg';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Abaut from '../components/About';
import ReportsDialog from '../components/ReportsDialog';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import AdminDialog from '../components/AdminDialog';
import LogsDialog from '../components/LogsDialog';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import MenuIcon from '@mui/icons-material/Menu';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import SchoolIcon from '@mui/icons-material/School';
import TutorialsDialog from '../components/TutorialsDialog';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

type Props = {
  hideUser?: boolean;
}

function HeaderMainFooter({ hideUser }: Props) {
  const { currentUser, setCurrentUser } = React.useContext(GlobalStateContext);
  const { userPermissions } = React.useContext(GlobalStateContext);
  const { getUser, logout } = useAuth();
  const [openAbaut, setOpenAbaut] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(false);
  const [openLogs, setOpenLogs] = useState(false);
  const [openTutorials, setOpenTutorials] = useState(false);

  const [openReports, setOpenReports] = useState(false);
  const { openReportsDialog, setOpenReportsDialog } = React.useContext(GlobalStateContext);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const navigate = useNavigate();


  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const loadUser = async () => {
    let u: User | null = null;
    if (localStorage.getItem("user")) {
      u = JSON.parse(localStorage.getItem("user") || "") as User;
    } else {
      u = await getUser();
    }

    if (u)
      setCurrentUser(u);
  }

  useEffect(() => {
    loadUser();
  }, [])

  const getName = () => {
    if (!currentUser || !currentUser.profile) return "";

    return currentUser.profile.given_name || currentUser.profile.name || currentUser.profile.preferred_username || currentUser.profile.nickname || currentUser.profile.sub;
  }

  function stringToHslColor(s: number, l: number) {
    var hash = 0;
    if (!currentUser) return '';
    for (var i = 0; i < (getName()?.length || 0); i++) {
      hash = (getName() || "A").charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
  }

  const firstLetters = () => {
    return getName()?.split(" ").map((word: string | any[]) => word.slice(0, 1));
  }

  return (<>
    <Abaut open={openAbaut} onClose={() => { setOpenAbaut(false) }} />
    <ReportsDialog />
    <AdminDialog open={openAdmin} onClose={() => setOpenAdmin(false)} />
    <LogsDialog open={openLogs} onClose={() => setOpenLogs(false)} />
    <TutorialsDialog open={openTutorials} onClose={() => setOpenTutorials(false)} />
    <AppBar position="static" color="primary" sx={{ backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
      <Toolbar>
        <Typography variant='h6'>
          <RouterLink className='flex flex-1' to="/"><img src={icon} style={{ height: "60px" }} />
          </RouterLink>
        </Typography>
        {!hideUser && (<>
          <div className='flex ml-3'>
            <IconButton
              id="basic-button"
              aria-controls={open ? 'basic-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
              onClick={handleClick}
              sx={{ color: 'white' }}>
              <MenuIcon />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem>
                <a onClick={() => { handleClose(); setOpenReportsDialog(true) }} className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center pr-4">
                  <PictureAsPdfIcon /> &nbsp; Relatórios
                </a>
              </MenuItem>


              {userPermissions.type === "admin" || userPermissions.type === 'super admin' ?
                <MenuItem>
                  <a onClick={() => { handleClose(); setOpenAdmin(true) }} className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center pr-4">
                    <SupervisedUserCircleIcon /> &nbsp; Usuários
                  </a>
                </MenuItem>
                :
                <></>
              }

              <MenuItem>
                <a onClick={() => { handleClose(); setOpenLogs(true) }} className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center">
                  <SyncAltIcon /> &nbsp; Logs
                </a>
              </MenuItem>

              <MenuItem>
                <a onClick={() => { { navigate(`/resultOverprice`) } }} className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center">
                  <AttachMoneyIcon /> &nbsp;Sobrepreço pré-calculado
                </a>
              </MenuItem>


              {process.env.REACT_APP_MANUAL_USO && process.env.REACT_APP_MANUAL_USO != "" &&
                <MenuItem>
                  <a href={process.env.REACT_APP_MANUAL_USO} target="_blank" className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center pr-4">
                    <MenuBook /> &nbsp; Manual
                  </a>
                </MenuItem>}

              {process.env.REACT_APP_FORMULARIO_AVALIACAO && process.env.REACT_APP_FORMULARIO_AVALIACAO != "" &&
                <MenuItem>
                  <a href={process.env.REACT_APP_FORMULARIO_AVALIACAO} target="_blank" className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center pr-4">
                    <TextSnippet /> &nbsp; Formulário de avaliação
                  </a>
                </MenuItem>}

              <MenuItem>
                <a onClick={() => { handleClose(); setOpenTutorials(true) }} className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center pr-4">
                  <SchoolIcon /> &nbsp; Tutoriais
                </a>
              </MenuItem>

              <MenuItem>
                <a onClick={() => { handleClose(); setOpenAbaut(true) }} className="text-base font-normal opacity-75 hover:opacity-100 cursor-pointer flex justify-end items-center pr-4">
                  <Info /> &nbsp; Sobre
                </a>
              </MenuItem>



            </Menu>
          </div>


          <div className='flex flex-1 justify-end'>

            <div className="ml-3 mr-4 max-w-[180px] font-normal text-white text-sm flex items-center gap-2" >
              <Avatar
                sx={{
                  bgcolor: "rgb(246 252 252)",
                  color: "#2B7A78"
                }}
              >
                {firstLetters()}
              </Avatar>
              <span className="flex-1 truncate">
                {getName()}
              </span>
            </div>

            <Button variant="text" onClick={() => logout()} startIcon={<Logout />} sx={{ color: 'white', fontSize: 16, mr: 4 }}>
              Sair
            </Button>

            <img src={ceat} style={{ height: "45px" }} />
            <img src={gsi} style={{ height: "45px" }} />
            <img src={mpmg} style={{ height: "45px" }} />

          </div>
        </>)}

      </Toolbar>
    </AppBar>
  </>);
}

export default HeaderMainFooter;
